import angular from 'angular'

import envRaw from '../utils/env-raw'

import Template from './gallery-retry.component.ejs'

angular
  .module('ggs.gallery-retry')
  .component('ggsGalleryRetry', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryRetryComponent,
    bindings: {
      ggsProperties: '<',
      ggsRetryRequestHandler: '<'
    }
  })

function GalleryRetryComponent($scope) {
  $scope.$ctrl = this
}
